import { SearchInput } from "@finanedi.es/storybook"
import Checkbox from "common/components/Checkbox"
import createImgURI from "common/utils/createImgURI"
import { catalogosSelector } from "features/Inventario/redux/selectors/catalogosSelector"
import { categoriasSelector } from "features/Inventario/redux/selectors/categoriasSelectors"
import {
  getArticulosByCategoria,
  selectAllArticulos,
  selectCategorias,
  setConceptoSearch,
  toggleSelectionArticulo,
} from "features/Inventario/redux/slices/catalogosSlice"
import { useDispatch } from "hooks/useDispatch"
import { useSelector } from "hooks/useSelector"
import { debounce } from "lodash"
import { MultiSelect } from "primereact/multiselect"
import { ProgressSpinner } from "primereact/progressspinner"
import React, { memo, useCallback, useMemo, useState } from "react"
import { CameraOff } from "react-feather"
import { useTranslation } from "react-i18next"
import "./styles.scss"

const ArticulosList = ({
  onArticuloSelection,
  maxHeight,
}: $TSMigrationFixMe) => {
  const { articulosByCategoria, fetchingMoreArticulos, fetchingArticulos } =
    useSelector(catalogosSelector)

  if (fetchingArticulos) {
    return (
      <div className='articulos-info-status'>
        {/* @ts-expect-error TS(2769): No overload matches this call. */}
        <ProgressSpinner strokeWidth={2} />
      </div>
    )
  }

  if (!fetchingArticulos && !Object.keys(articulosByCategoria).length) {
    return (
      <div className='articulos-info-status'>
        <span>No tienes artículos</span>
      </div>
    )
  }

  return (
    <div
      style={{ height: maxHeight }}
      className='articulos-items'
    >
      {Object.keys(articulosByCategoria).map((categoriaName, idx) => {
        const { articulos = [], totalCount = 0 } =
          articulosByCategoria[categoriaName]

        return (
          <React.Fragment key={categoriaName}>
            <div className='articulo-header'>
              <p className='m-0'>
                {categoriaName} ({totalCount})
              </p>
            </div>

            {articulos.map((articulo: $TSMigrationFixMe) => (
              // eslint-disable-next-line no-use-before-define
              <Articulo
                key={articulo.id}
                // @ts-expect-error TS(2322): Type '{ key: $TSFixMe; articulo: $TSFixMe; onArticuloSelecti...
                articulo={articulo}
                onArticuloSelection={onArticuloSelection}
              />
            ))}

            {fetchingMoreArticulos &&
              idx === Object.keys(articulosByCategoria).length && (
                <div className='d-flex align-items-center justify-content-center'>
                  <ProgressSpinner style={{ width: "100px", height: "50px" }} />
                </div>
              )}
          </React.Fragment>
        )
      })}
    </div>
  )
}

// @ts-expect-error TS(2339): Property 'articulo' does not exist on type '{}'.
const Articulo = memo(({ articulo, onArticuloSelection }) => (
  <div className='articulo-item'>
    <Checkbox
      checked={articulo.isSelected}
      toggle={(e: $TSMigrationFixMe) => {
        e?.stopPropagation()
        onArticuloSelection(articulo)
      }}
    />

    <div className='articulo-image'>
      {articulo.thumbnailBase64 ? (
        <img
          src={createImgURI(
            articulo.thumbnailBase64,
            articulo.fichero?.mediaType
          )}
          alt={`Imagen del artículo ${articulo.concepto}`}
        />
      ) : (
        <CameraOff />
      )}
    </div>

    <span>{articulo.concepto}</span>
  </div>
))

// @ts-expect-error TS(2339): Property 'visible' does not exist on type '{}'.
const ArticulosSelection = memo(({ visible = true, maxHeight }) => {
  const { t } = useTranslation()
  const [selectAll, setSelectAll] = useState(false)
  const [inputSearch, setInputSearch] = useState("")

  const { categoriasSelected } = useSelector(catalogosSelector)
  const { allCategorias } = useSelector(categoriasSelector)
  const dispatch = useDispatch()

  const categoriasOptions = useMemo(
    () =>
      allCategorias.map((categoria: $TSMigrationFixMe) => ({
        label: categoria.nombre,
        value: categoria.id,
      })),
    [allCategorias]
  )

  const onArticuloSelection = useCallback(
    (articulo: $TSMigrationFixMe) => {
      dispatch(toggleSelectionArticulo(articulo))
    },
    [dispatch]
  )

  const onSelectAllArticulos = () => {
    setSelectAll((prev) => !prev)
    dispatch(selectAllArticulos(!selectAll))
  }

  const onFilterArticulo = useCallback(
    (search: $TSMigrationFixMe) => {
      dispatch(setConceptoSearch(search))
      // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
      dispatch(getArticulosByCategoria())
    },
    [dispatch]
  )

  const onCategoriasChange = (e: $TSMigrationFixMe) => {
    dispatch(selectCategorias(e.target?.value))
    // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
    dispatch(getArticulosByCategoria())
  }

  const debounceFilterArticulos = useMemo(
    () => debounce((search) => onFilterArticulo(search), 300),
    [onFilterArticulo]
  )

  const handleChangeSearch = (value: string) => {
    setInputSearch(value)
    debounceFilterArticulos(value)
  }

  return (
    <div className={`h-100 container-articulos ${!visible ? "hide" : ""}`}>
      <div className='articulos-header'>
        <span className='ml-3'>
          <Checkbox
            checked={selectAll}
            toggle={onSelectAllArticulos}
          />
          <p className='m-0 ml-3'>
            {t("catalogos.editCreate.articleSection.filterAll")}
          </p>
        </span>

        <div className='tw-flex tw-h-10 tw-flex-row tw-gap-3'>
          <MultiSelect
            placeholder={`${t(
              "catalogos.editCreate.articleSection.placeholderCategory"
            )}`}
            options={categoriasOptions}
            onChange={onCategoriasChange}
            value={categoriasSelected}
            emptyFilterMessage={`${t(
              "catalogos.editCreate.articleSection.emptyCategory"
            )}`}
            filter
            showClear
          />
          <SearchInput
            placeholder={`${t("validaciones.placeholderSearch")}`}
            onChange={(ev: string) => {
              handleChangeSearch(ev)
            }}
            inputValue={inputSearch}
            className='tw-h-10 tw-w-full sm:tw-w-72'
          />
        </div>
      </div>

      <ArticulosList
        maxHeight={maxHeight}
        onArticuloSelection={onArticuloSelection}
      />
    </div>
  )
})

export default ArticulosSelection
